import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=478f1715&"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=js&"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports